import React, {Fragment,useState,useEffect,Suspense} from 'react';
import { Table,Row, Col,
  Card, CardBody,
  CardTitle,Button } from 'reactstrap';
import Parametri from '../../parametri';

import FormGridFormRow from '../SchedaVociDiBilancio/FormGridFormRow';

import TabellaRicerca from '../tabellaricerca.js';

import Clessidra from '../Clessidra.js';
import Interrogativo from '../../immagini/interrogativo-azzurro.png';

import Modale from '../Modale.js';

//const STATO_INDEFINITO = 0;
const STATO_RICERCA_ELENCO = 1;
const STATO_ELENCO = 2;
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_VAI_IN_INSERISCI = 4;

function TabellaAssemblee(props) {
    
    const operazione = "elencoAssemblee";
      
    const [elencoAssemblee,setElencoAssemblee]=useState('');
    const [statoPagina,setStatoPagina]=useState(STATO_RICERCA_ELENCO);
    const [error,setError]=useState('');
   
    // nota: accessor DEVE chiamarsi così a causa di requisiti dei componenti usati, non fatti da me
    const colonne = [
      {
        etichetta: '',
        accessor: 'ID'
      },
      {
        etichetta: 'Prima Conv.',
        accessor: 'DATA_PRIMA',
        pdf: 1,
      },
      {
        etichetta: "Seconda Conv.",
        accessor: 'DATA_SECONDA',
        pdf: 1,
      },
      {
        etichetta: "Ordine del Giorno",
        accessor: 'ODG',
        pdf: 1,
      },
    ];
    const arrayTipiDati=[];

    function VaiModifica(id) {
      //setStatoPagina(STATO_VAI_IN_MODIFICA);
      //setIdModifica(id);
    }

    function VaiElimina(id) {
      //setStatoPagina(STATO_VAI_IN_ELIMINA);
      //setIdModifica(id);
    }

    function callbackTermineModifica() {
      setStatoPagina(STATO_RICERCA_ELENCO);
    }

    useEffect(() => {
      if(statoPagina===STATO_RICERCA_ELENCO){
        // parametri per inviare i dati al server:
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"assembleeElenco",tipo:props.tipo,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
            (valoreDiRitorno) => {
              if(valoreDiRitorno.risultatoOperazione===0){
                alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
              }
              if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
              if(valoreDiRitorno.risultatoOperazione===1){
                setElencoAssemblee(valoreDiRitorno.elenco);
                setStatoPagina(STATO_ELENCO);}
            },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
      }    
    },[statoPagina])

    // temporanea attivazione solo per EMA18
    if (props.identitaSelezionata.nome_database!="EMA18") return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Funzione presto disponibile</div>)

    if (statoPagina == STATO_RICERCA_ELENCO) {
      return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/></div>)
    }

    if (statoPagina == STATO_ERRORE_CONNESSIONE) {
      return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Errore nella ricerca dei dati</div>)
    }

    if (statoPagina == STATO_ELENCO) {
      return (
        <div style={{height: props.dimensioniApp.yMain, overflow:"hidden", display:"flex", flexDirection:"column"}}>
        <CardBody>
      
        <div>
          <CardTitle>Elenco assemblee {props.tipo=="soci" && " dei soci"}{props.tipo=="direttivo" && " del direttivo"}</CardTitle>
          <Button color="success" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Nuova Assemblea</Button>
        </div>
        </CardBody>
        {elencoAssemblee ?
          <TabellaRicerca 
            titolo={`Elenco Assemblee`} 
            columns={colonne} data={elencoAssemblee} arrayTipiDati={arrayTipiDati} campoChiave={0} campoOrdinamento={1} nascondiColonna={0} callbackSelezionaElemento={VaiModifica} callbackEliminaElemento={VaiElimina}/>
          : 
            <div>Nessun dato presente</div>
        }
                      
      </div>
      )
    }
  
   return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Assemblee: Pagina non trovata ({statoPagina})</div>)
}
export default TabellaAssemblee;